//TODO: Remove pds which are unnecessary for PAID
export const COMPANY_ESIGN_CONSENT_DISCLOSURE = "/assets/pdf/paid_esign_consent_disclosure.pdf";
export const COMPANY_TECHNOLOGY_PLATFORM_AGREEMENT =
  "/assets/pdf/technology_platform_agreement.pdf";
//Paid
export const COMPANY_TERMS_AND_CONDITIONS = "/assets/pdf/Paid - Terms and Conditions.pdf";
